import React, { Component } from 'react'
import { Link } from 'gatsby'
import get from 'lodash/get'
import { buildURL } from '../../utils/url'
import EventTracker from './../../helpers/EventTracker'

export default class StoryBlockWidget extends Component {
    getDonateUrl = () => {
        const { donateAmount, recurring, donateReason, externalHyperlink, internalHyperlink } = this.props.data
        let { pageDonation, preview } = this.props

        if (!pageDonation) {
            pageDonation = this.props.data.story ? this.props.data.story.pageDonation : null
        }
        if (preview) {
            pageDonation = pageDonation?.fields
        }

        if (externalHyperlink) return externalHyperlink
        if (internalHyperlink) return buildURL(internalHyperlink)

        if (pageDonation && pageDonation.slug) {
            return `/donation-page/${pageDonation.slug}`
        }

        let paramStrings = [`recurring=${recurring}`]
        if (donateAmount) paramStrings.push(`amount=${donateAmount}`)
        if (donateReason) paramStrings.push(`reason=${donateReason}`)

        return `/foundation/donation-form?${paramStrings.join('&')}`
    }

    donate = () => {
        const { donateAmount, textButton } = this.props.data

        return (
            <span className="buttonLink read-more-link">
                <span className="read-more-link-text">{textButton ? textButton : `Donate${donateAmount ? ` $${donateAmount}` : ''}`}</span>
                {!textButton && <i className="fa fa-heart icon view-more-icon" />}
            </span>
        )
    }

    render() {
        const { className } = this.props
        const { title, summary, backgroundImage } = this.props.data

        const backgroundImageUrl = backgroundImage ? backgroundImage.file.url : null
        const backgroundImageTitle = backgroundImage ? backgroundImage.title : null

        const donateUrl = this.getDonateUrl()

        return (
            <Link to={donateUrl} className={`block story-block ${className ? className : ''}`} onClick={() => EventTracker.customEvent(EventTracker.EVENT_CATEGORIES.STORY_BLOCK, EventTracker.EVENT_TYPES.CLICK, 'CARD_CLICK')} style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="block-heading" role="img" aria-label={backgroundImageTitle}>
                    <img src={backgroundImageUrl} alt={backgroundImageTitle} />
                </div>

                <div className="block-info">
                    <div className="block-body">
                        <h4>{title}</h4>
                        <p>{get(summary, 'summary')}</p>
                    </div>

                    <div className="block-links">{this.donate()}</div>
                </div>
            </Link>
        )
    }
}
